'use client';
import styles from './styles.module.scss';

import { useTranslation } from '@/hook';
import Typography from '@/components/shared/typography/typography.component';
import CarDisplayCardClient from '@/components/shared/car-details-card/car-details-car-client.component';
import Link from '@/components/WrappedLink';
import { IRecentlyAddedResult } from '@/types';

export default function SylndrCars({
    lang,
    recentlyAddedData,
}: {
    lang: 'ar' | 'en';
    recentlyAddedData: IRecentlyAddedResult;
}) {
    const { t } = useTranslation();

    return (
        <section className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.headerDescriptionContainer}>
                    <Typography className={styles.header} variant="h5Bold">
                        {t('Recently added')}
                    </Typography>

                    <Typography
                        className={styles.subHeader}
                        variant="subtitle1"
                    >
                        {t('Sylndr certified cars')}
                    </Typography>
                </div>
                <div className={styles.desktopActionButton}>
                    <Link
                        style={{
                            width: '200px',
                            height: '48px',
                            display: 'flex',
                        }}
                        className="sylndr_button primary"
                        href={`/${lang}/buy-used-cars`}
                    >
                        <Typography
                            variant="body1Medium"
                            style={{
                                paddingTop: '12px',
                                paddingBottom: '12px',
                                paddingRight: '20px',
                                paddingLeft: '20px',
                                width: 'fit-content',
                            }}
                        >
                            {' '}
                            {t('browse all cars')}
                        </Typography>
                    </Link>
                </div>
            </div>
            <div className={styles.carsContainer}>
                {recentlyAddedData?.data?.slice(0, 4).map((car, index) => {
                    return (
                        <div className={styles.card} key={index}>
                            <CarDisplayCardClient
                                id={car.id}
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                cardTitle={`${t(car.make)} ${car.model} ${
                                    car.year
                                }`}
                                carName={car.sfVehicleName}
                                trim={car.trim}
                                installmentPrice={car?.installmentPrice}
                                totalPrice={car.sylndrSellingPrice}
                                kilometers={car.kilometers}
                                year={car.year}
                                transmission={car.transmission}
                                images={
                                    car?.images.length !== 0 ? car?.images : []
                                }
                                isReserved={car.isReserved}
                                make={car.make}
                                model={car.model}
                                sourceScreen={'Home Page'}
                                appliedFilter={false}
                                appliedSort={false}
                                position={index + 1}
                                isPurchaseInProgress={car.isPurchaseInProgress}
                                discountPrice={car?.discountPrice}
                                isNewlyAdded={car?.isNewlyAdded}
                            />
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
